import { Theme } from "@mui/material";
import { SxProps } from "@mui/system";
import { alignItemsFlexEnd, flexRow, flexRowCenterCenter } from "styles/index";

// Explicit SxProps<Theme> annotation omitted here — the spread + responsive height combination
// triggers a TypeScript false-positive due to MUI's complex union types. Compatibility is still
// enforced at every usage site where the value is assigned to an `sx` prop.
export const appBar = {
  ...flexRow,
  ...alignItemsFlexEnd,
  width: "100%",
  height: { xs: "48px", lg: "70px" },
  boxShadow: "none",
  background: `linear-gradient(
    116.41deg,
    #eff4fb 16.09%,
    #f7f3ff 44.79%,
    #eff4fb 59.94%,
    #f7f4ff 95.81%
  ) !important`,
  borderRadius: "0px",
} as SxProps<Theme>;

export const mainNavbar = (): SxProps<Theme> => {
  return {
    height: { xs: "46px", lg: "68px" },
    width: "100%",
    marginLeft: "5px",
    marginRight: "5px",
    borderRadius: "15px 15px 15px 15px",
    backgroundColor: "transparent !important",
  };
};

export const logoAdminName = (theme: Theme): SxProps<Theme> => {
  return {
    ...flexRowCenterCenter,
    fontSize: "32px",
    fontWeight: "900",
    marginLeft: "7px",
    color: theme.palette.common.white,
  };
};

export const mainNavbarInnerBox: SxProps<Theme> = {
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const navbarLocationsBox = (viewWidth: number): SxProps<Theme> => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: viewWidth > 992 ? "400px" : "auto",
    color: "#222222",
  };
};

export const navbarSearchIcon: SxProps<Theme> = {
  backgroundColor: "#eeeeee",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "10px",
  borderRadius: "50%",
};
